import React from 'react'
import ManagePlan from '../../../components/AdminPlan/index'

const PlanPage = () => {
    return (
        <div class="w-full">
            <ManagePlan />
        </div>
    )
}

export default PlanPage
